import React from "react";
import { useNavigate } from "../i18n/router";
import { Calendar, Clock, MapPin, ArrowRight, Heart } from "lucide-react";
import EventTypeBadge from "./EventTypeBadge";
import { uiLocale } from "../i18n/LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function EventMiniCard({ event, saved, onToggleSave, user }) {
  const navigate = useNavigate();

  return (
    <div
      className="eunoia-surface p-5 flex items-start gap-4 hover:-translate-y-0.5 transition-all cursor-pointer group relative"
      onClick={() => navigate(`/events/${event.id}`)}
      data-testid={`event-mini-${event.id}`}
    >
      {/* Date block */}
      <div className="w-14 h-14 rounded-xl flex-shrink-0 flex flex-col items-center justify-center"
        style={{ backgroundColor: "var(--eunoia-accent-whisper)" }}>
        <span className="text-lg font-bold leading-none" style={{ color: "var(--eunoia-accent)" }}>
          {new Date(event.date).getDate()}
        </span>
        <span className="text-[10px] uppercase mt-0.5" style={{ color: "var(--eunoia-soft)" }}>
          {new Date(event.date).toLocaleDateString(uiLocale(), { month: "short" })}
        </span>
      </div>

      {/* Info */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1 flex-wrap">
          <h3 className="text-sm font-semibold truncate group-hover:underline" style={{ color: "var(--eunoia-deep)" }}>{event.title}</h3>
          <EventTypeBadge type={event.type} />
        </div>
        <div className="flex items-center gap-3 text-xs" style={{ color: "var(--eunoia-soft)" }}>
          <span className="flex items-center gap-1"><Clock className="h-3 w-3" />{event.time}</span>
          {event.city && <span className="flex items-center gap-1"><MapPin className="h-3 w-3" />{event.city}</span>}
        </div>
      </div>

      {/* Save button */}
      {user && onToggleSave && (
        <button
          className="flex-shrink-0 p-1.5 rounded-full hover:bg-black/5 transition-colors"
          onClick={(e) => { e.stopPropagation(); onToggleSave(event.id); }}
          data-testid={`save-event-${event.id}`}
        >
          <Heart className={`h-4 w-4 transition-colors ${saved ? 'fill-red-400 text-red-400' : ''}`}
            style={{ color: saved ? undefined : "var(--eunoia-soft)" }} />
        </button>
      )}

      <ArrowRight className="h-4 w-4 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" style={{ color: "var(--eunoia-accent)" }} />
    </div>
  );
}
